import { render } from "./AppInlineMenu.vue?vue&type=template&id=179cb382"
import script from "./AppInlineMenu.vue?vue&type=script&lang=js"
export * from "./AppInlineMenu.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__